import { render, staticRenderFns } from "./RoomGroupVideoFilmHeader.vue?vue&type=template&id=25779db9&scoped=true&"
import script from "./RoomGroupVideoFilmHeader.vue?vue&type=script&lang=js&"
export * from "./RoomGroupVideoFilmHeader.vue?vue&type=script&lang=js&"
import style0 from "./RoomGroupVideoFilmHeader.vue?vue&type=style&index=0&id=25779db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25779db9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25779db9')) {
      api.createRecord('25779db9', component.options)
    } else {
      api.reload('25779db9', component.options)
    }
    module.hot.accept("./RoomGroupVideoFilmHeader.vue?vue&type=template&id=25779db9&scoped=true&", function () {
      api.rerender('25779db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Group/RoomGroupCall/RoomGroupVideoFilmHeader.vue"
export default component.exports